var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("footer", [
    _c("div", { staticClass: "footerlogos" }, [
      _c("div", { staticClass: "footerlogo-left-alt" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "footercontact-alt" },
          [
            _vm._v("\n                The Chicago Athenaeum"),
            _c("BR"),
            _vm._v(
              " 601 South Prospect Street,\n                Galena, Illinois 61036, USA"
            ),
            _c("BR"),
            _vm._v(" "),
            _c("strong", [_vm._v("Tel:")]),
            _vm._v(" +1\n                815 777 4444 | "),
            _c("strong", [_vm._v("Fax:")]),
            _vm._v(" +1 815 777 2471\n                "),
            _c("BR"),
            _vm._v(" "),
            _c("strong", [_vm._v("E-mail:")]),
            _vm._v(" curatorial@chicagoathenaeum.org\n            "),
          ],
          1
        ),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "footercontact-alt" },
          [
            _vm._v("\n                The European Centre for Architecture"),
            _c("BR"),
            _vm._v(" Art Design and\n                Urban Studies"),
            _c("BR"),
            _vm._v(
              " 28 Butlers Court Sir John Rogerson's\n                Quay, Dublin 2, Ireland"
            ),
            _c("BR"),
            _vm._v(" "),
            _c("strong", [_vm._v("Tel:")]),
            _vm._v(
              " 00 353\n                (0) 1 670 8781,\n                "
            ),
            _c("strong", [_vm._v("Email:")]),
            _vm._v(" fachanan@europeanarch.eu\n            "),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footerlogo-right" }, [_vm._t("default")], 2),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      { attrs: { href: "https://www.chi-athenaeum.org/", target: "_blank" } },
      [
        _c("img", {
          staticClass: "tca-logo",
          attrs: { src: "/images/TCA-new.png" },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      { attrs: { href: "https://www.europeanarch.eu/", target: "_blank" } },
      [
        _c("img", {
          staticClass: "ecadus-logo",
          attrs: { src: "/images/ECADUS-LOGOTYPE.png" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }